module.exports = __webpack_public_path__ + "img/20210818120600621dqk.de29ff77.png";